<script lang="ts">
  import novelIcon from './assets/novel-icon.png'
  import CnfForm from "./components/CnfForm.svelte";
  import RulesExplainer from "./components/RulesExplainer.svelte";

  // Simple routing state
  let currentPage = $state('form'); // 'form' or 'rules'

  function navigateTo(page: string) {
    currentPage = page;
  }
</script>

<svelte:head>
  <title>CNF Requirement Checker</title>
  <meta name="description" content="Determine if your company needs to submit a Claim Notification Form for HMRC R&D tax relief." />
</svelte:head>

<main class="min-h-screen flex flex-col items-center justify-center bg-gray-100 text-gray-900">
  <header class="flex flex-row items-center p-4 mb-4">
    <img
            src={novelIcon}
            alt="Novel"
            class="w-24 h-24 object-contain mr-6"
            aria-describedby="app-description"
    />
    <div>
      <h1 class="text-4xl font-bold mb-2">CNF Requirement Checker</h1>
      <p id="app-description" class="text-lg">
        Determine if your company needs to submit a Claim Notification Form for HMRC R&D tax relief.
      </p>
    </div>
  </header>

  {#if currentPage === 'form'}
    <CnfForm/>
  {:else if currentPage === 'rules'}
    <RulesExplainer/>
  {/if}

  <footer class="mt-8 text-center text-sm text-gray-600 p-4">
    {#if currentPage === 'form'}
      <p>Need more information? <button onclick={() => navigateTo('rules')} class="text-blue-600 hover:underline">View CNF Rules Explanation</button></p>
    {:else}
      <p><button onclick={() => navigateTo('form')} class="text-blue-600 hover:underline">← Back to CNF Checker</button></p>
    {/if}
  </footer>
</main>

<style>
  /* Custom styles for accessibility and readability */
  :global(body) {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }
</style>
